module.exports = __webpack_public_path__ + "static/media/2012_Population_totalRate.cbe47132.png";